import React from 'react';
import TutorialMascot from './TutorialMascot';
import './TutorialLauncher.css';

/**
 * What's left of the walkthrough once it's minimised.
 *
 * It has to be findable without being in the way: it sits in a corner, states
 * how far through the learner is, and puts everything back exactly where they
 * left it. It also carries its own exit, so a learner who minimised the
 * tutorial to get on with something else doesn't have to reopen it just to
 * close it.
 */
const TutorialLauncher = ({ progress, onResume, onExit }) => (
  <div className="tutorial-launcher">
    <button type="button" className="tutorial-launcher-resume" onClick={onResume}>
      <span className="tutorial-launcher-mascot">
        <TutorialMascot talking={false} cheering={false} />
      </span>

      <span className="tutorial-launcher-text">
        <span className="tutorial-launcher-title">Resume tutorial</span>
        <span className="tutorial-launcher-step">
          Step {progress.current} of {progress.total}
        </span>
      </span>
    </button>

    <button
      type="button"
      className="tutorial-launcher-exit"
      onClick={onExit}
      aria-label="Exit tutorial"
      title="Exit the tutorial"
    >
      ✕
    </button>

    <span className="tutorial-launcher-progress">
      <span
        className="tutorial-launcher-progress-fill"
        style={{ width: `${progress.percentage}%` }}
      />
    </span>
  </div>
);

export default TutorialLauncher;
